// ============================================
// SECTION — Research
// ============================================

import { useState } from "react";
import {
  RiArrowDownSLine,
  RiListCheck2,
  RiSearchLine,
  RiFileTextLine,
  RiDatabase2Line,
} from "react-icons/ri";
import { RESEARCH_ACCORDION } from "../data/content";
import { useInView } from "../hooks/useInView";
import "./Research.css";

const ACC_ICONS = [
  <RiSearchLine />,
  <RiListCheck2 />,
  <RiFileTextLine />,
  <RiDatabase2Line />,
];

export default function Research() {
  const [open, setOpen] = useState(0);
  const [ref, visible] = useInView(0.1);

  return (
    <section id="research" className="research section-pad">
      <div className="container research__container" ref={ref}>
        <div className={`research__grid fade-up ${visible ? "visible" : ""}`}>
          {/* Left: heading + description + quote */}
          <div className="research__left">
            <span className="section-label">Research &amp; Scholarship</span>
            <h2 className="section-title">Evidence-Based Practice</h2>
            <p className="section-sub research__desc">
              Our work is informed by rigorous research on family structure,
              social bonds, and reentry outcomes—translating evidence into
              practical strategies.
            </p>
            <div className="research__quote">
              <span className="research__quote-mark research__quote-mark--open" aria-hidden="true">&ldquo;</span>
              <blockquote>
                We bridge data, lived experience, and policy to strengthen
                families and reduce recidivism.
              </blockquote>
              <span className="research__quote-mark research__quote-mark--close" aria-hidden="true">&rdquo;</span>
            </div>
          </div>

          {/* Right: accordion */}
          <div className="research__accordion">
            {RESEARCH_ACCORDION.map((item, i) => (
              <div
                key={i}
                className={`acc-item ${open === i ? "acc-item--open" : ""}`}
              >
                <button
                  className="acc-item__header"
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <span className="acc-item__header-left">
                    <span className="acc-item__header-icon">
                      {ACC_ICONS[i]}
                    </span>
                    {item.title}
                  </span>
                  <RiArrowDownSLine
                    className={`acc-item__arrow ${open === i ? "acc-item__arrow--open" : ""}`}
                  />
                </button>

                <div
                  className={`acc-item__body ${open === i ? "acc-item__body--open" : ""}`}
                >
                  {item.type === "text" ? (
                    <p>{item.body}</p>
                  ) : (
                    <ul className="acc-item__list">
                      {item.items.map((t) => (
                        <li key={t}>
                          <span className="acc-item__bullet" />
                          {t}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
